<template>
  <div :style="{display: 'flex',width: showOtherField ? '1020px':'780px'}">
    <div class="form-column">
      <el-form class="result-form">
        <table cellpadding="0" cellspacing="0">
          <tr>
            <td class="header">{{ $t('FileHistory.fileName') }}</td>
            <td><span style="margin-left: 10px;">{{ details.fileName }}</span></td>
            <td class="header">{{ $t('SeaExport.BusinessReferenceNo') }}</td>
            <td><el-input v-model="resultJson.customerRefNo" no="customerRefNo" @focus="handleFocus('customerRefNo')" /></td>
          </tr>
          <tr>
            <td class="header">{{ $t('SeaExport.SerialNo') }}</td>
            <td><span style="margin-left: 10px;">{{ details.fileNo }}</span></td>
            <td class="header">{{ $t('SeaExport.BusinessNumber') }}</td>
            <td><span style="margin-left: 10px;">{{ details.jobNo }}</span></td>
          </tr>
          <tr>
            <td class="header is-require">{{ $t('SeaExport.ConsignationCompany') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.customerId" no="1" @change="mapperCustomerId(job, resultJson)" @focus="handleFocus('customerId')" />
                </el-form-item>
                <cargo-company-select
                  no="2"
                  :method-params="{customer:true,companyLob:'seaExport',active:true}"
                  :default-value="job.customerId||''"
                  style="width: 150px;"
                  @change="p=>{job.customerId=p.value}"
                  @focus="handleFocus('customerId')"
                />
              </div>
            </td>
            <td class="header">{{ $t('SeaExport.WarehouseNo') }}</td>
            <td><el-input v-model="resultJson.warehouseNo" no="3" @focus="handleFocus('warehouseNo')" /></td>
          </tr>
          <tr>
            <td rowspan="7" class="header">{{ $t('Message.Shipper') }}</td>
            <td><el-form-item><el-input v-model="job.shipperLine1" no="4" @focus="handleFocus('shipper')" /></el-form-item></td>
            <td class="header">{{ $t('SeaExport.BLForm') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.orderType" no="5" @change="mapperOrderType(job, resultJson)" @focus="handleFocus('orderType')" /></el-form-item>
                <el-select
                  v-model="job.orderType"
                  no="6"
                  @focus="handleFocus('orderType')"
                >
                  <el-option
                    v-for="(item,index) in blModeList"
                    :key="index"
                    :label="item.name"
                    :value="item.serialNumber"
                  />
                </el-select>
              </div>
            </td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.shipperLine2" no="7" @focus="handleFocus('shipper')" /></el-form-item></td>
            <td class="header">{{ $t('SeaExport.LCL') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.containerLoadType" no="8" @change="mapperLoadType(job, resultJson)" @focus="handleFocus('containerLoadType')" /></el-form-item>
                <el-select v-model="job.containerLoadType" no="9" @focus="handleFocus('containerLoadType')">
                  <el-option
                    v-for="(item,index) in (containerLoadTypes)"
                    :key="index"
                    :label="isZh?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </div>
            </td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.shipperLine3" no="10" @focus="handleFocus('shipper')" /></el-form-item></td>
            <td class="header is-require">{{ $t('SeaExport.ShippingCompany') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.carrier" no="11" @change="mapperShipName(job, resultJson)" @focus="handleFocus('carrier')" /></el-form-item>
                <cargo-company-select
                  no="12"
                  :method-params="{companyLob:'seaExport',seaCmp:true,active:true}"
                  :default-value="job.carrierId||''"
                  style="width: 150px;"
                  @change="p=>{job.carrierId=p.value}"
                  @focus="handleFocus('carrier')"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.shipperLine4" no="13" @focus="handleFocus('shipper')" /></el-form-item></td>
            <td class="header is-require">{{ $t('Payment.vessel') }}</td>
            <td><el-form-item><el-input v-model="resultJson.vessel" no="14" @focus="handleFocus('vessel')" /></el-form-item></td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.shipperLine5" no="15" @focus="handleFocus('shipper')" /></el-form-item></td>
            <td class="header is-require">{{ $t('Payment.voyage') }}</td>
            <td><el-form-item><el-input v-model="resultJson.voyage" no="16" @focus="handleFocus('voyage')" /></el-form-item></td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.shipperLine6" no="17" @focus="handleFocus('shipper')" /></el-form-item></td>
            <td class="header is-require">{{ $t('queryJob.dateOfDeparture') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.etd" no="18" @change="mapperEtd(job, resultJson)" @focus="handleFocus('etd')" /></el-form-item>
                <el-date-picker
                  no="19"
                  :value="job.etd"
                  type="date"
                  style="width: 150px;"
                  value-format="yyyy-MM-dd"
                  @input="etdChange"
                  @focus="handleFocus('etd')"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.shipperLine7" no="20" @focus="handleFocus('shipper')" /></el-form-item></td>
            <td colspan="2" />
          </tr>
          <tr>
            <td rowspan="7" class="header">{{ $t('Message.Consignee') }}</td>
            <td><el-form-item><el-input v-model="job.consigneeLine1" no="21" @focus="handleFocus('consignee')" /></el-form-item></td>
            <td class="header">{{ $t('SeaExport.TransportationClause') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.freightTerm" no="22" @change="mapperFreightTerm(job, resultJson)" @focus="handleFocus('freightTerm')" /></el-form-item>
                <cargo-advance-select
                  no="23"
                  :select-type="selectTypeNames.basic_data_ShippingTerm"
                  filterable
                  :clearable="false"
                  :default-value="job.freightTerm"
                  style="width: 150px;"
                  @parentCallBack="p=>{job.freightTerm=p.value}"
                  @focus="handleFocus('freightTerm')"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.consigneeLine2" no="24" @focus="handleFocus('consignee')" /></el-form-item></td>
            <td class="header is-require">{{ $t('SeaExport.FreightTerm') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.paymentTerm" no="25" @change="mapperPaymentTerm(job, resultJson)" @focus="handleFocus('paymentTerm')" /></el-form-item>
                <cargo-advance-select
                  no="26"
                  :select-type="selectTypeNames.basic_data_PaymentTerm"
                  filterable
                  :clearable="false"
                  :default-value="job.paymentTermMBL"
                  style="width: 150px;"
                  @parentCallBack="p=>{job.paymentTermMBL=p.value;}"
                  @focus="handleFocus('paymentTerm')"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.consigneeLine3" no="27" @focus="handleFocus('consignee')" /></el-form-item></td>
            <td class="header is-require" rowspan="2">{{ $t('CargoMsg.Cargo_CartonQuantity') }}</td>
            <td rowspan="2">
              <div style="max-height: 100px;overflow-y: auto;">
                <div v-for="(item,index) in job.seaEQ" :key="index">
                  <div style="display: flex">
                    <div style="width: 49%">
                      <el-input v-model="item.eqQuantity" no="eqQuantity" style="width: 40px;" @focus="handleFocus('containerInfos')" />
                      {{ item.showEQ }}
                    </div>
                    <div style="display:flex;">
                      <cargo-advance-select
                        no="eqSize"
                        :select-type="selectTypeNames.local_cache_EQSize"
                        :fields="['code']"
                        filterable
                        :placeholder="' '"
                        :show-copy="false"
                        :default-value="item.eqSize"
                        style="width: 75px;"
                        tag-name="code"
                        @parentCallBack="p=>{changeSizeCallBack(item, p)}"
                        @focus="handleFocus('containerInfos')"
                      />
                      <cargo-advance-select
                        no="eqType"
                        :select-type="selectTypeNames.basic_data_EQType"
                        :fields="['code']"
                        filterable
                        :placeholder="' '"
                        :show-copy="false"
                        :default-value="item.eqType"
                        style="width: 75px;"
                        tag-name="code"
                        @parentCallBack="p=>{changeTypeCallBack(item, p)}"
                        @focus="handleFocus('containerInfos')"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.consigneeLine4" no="29" @focus="handleFocus('consignee')" /></el-form-item></td>
            <!--            <td class="header">{{ $t('SeaExport.ContainerAmount') }}</td>-->
            <!--            <td><el-form-item><el-input v-model="resultJson.containerNo" no="30" /></el-form-item></td>-->
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.consigneeLine5" no="31" @focus="handleFocus('consignee')" /></el-form-item></td>
            <td class="header">{{ $t('queryJob.IncoTerm') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.incoTerm" no="32" @change="mapperIncoTerm(job, resultJson)" @focus="handleFocus('incoTerm')" /></el-form-item>
                <cargo-advance-select
                  no="33"
                  :select-type="selectTypeNames.basic_data_IncoTerm"
                  filterable
                  :clearable="false"
                  :default-value="job.incoTerm"
                  style="width: 150px;"
                  @parentCallBack="p=>{job.incoTerm=p.value}"
                  @focus="handleFocus('incoTerm')"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.consigneeLine6" no="34" @focus="handleFocus('consignee')" /></el-form-item></td>
            <td class="header">{{ $t('Payment.contactPerson') }}</td>
            <td><el-form-item><el-input v-model="resultJson.customerContact" no="35" @focus="handleFocus('customerContact')" /></el-form-item></td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.consigneeLine7" no="36" @focus="handleFocus('consignee')" /></el-form-item></td>
            <td colspan="2" />
          </tr>
          <tr>
            <td rowspan="7" class="header">{{ $t('Message.Notify') }}</td>
            <td><el-form-item><el-input v-model="job.notifyLine1" no="37" @focus="handleFocus('notify')" /></el-form-item></td>
            <td rowspan="7" class="header">{{ $t('SeaExport.CargoSize') }}</td>
            <td rowspan="7">
              <div style="position: relative;">
                <!--                <div v-if="!showGoods" style="cursor: pointer; position: absolute; top: 0; right: 0; color: deepskyblue; z-index: 1;" @click="onMultDoc()">{{ $t('SeaExport.MultipleMode') }}</div>-->
                <el-form-item><el-input v-model="resultJson.measurements" type="textarea" resize="none" :rows="11" no="38" @focus="handleFocus('measurements')" /></el-form-item>
              </div>
            </td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.notifyLine2" no="39" @focus="handleFocus('notify')" /></el-form-item></td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.notifyLine3" no="40" @focus="handleFocus('notify')" /></el-form-item></td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.notifyLine4" no="41" @focus="handleFocus('notify')" /></el-form-item></td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.notifyLine5" no="42" @focus="handleFocus('notify')" /></el-form-item></td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.notifyLine6" no="43" @focus="handleFocus('notify')" /></el-form-item></td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.notifyLine7" no="44" @focus="handleFocus('notify')" /></el-form-item></td>
          </tr>
          <tr>
            <td class="header  is-require">{{ $t('Payment.portOfLoading') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.loadingPortCode" no="45" @change="mapperSeaPort('loadingPortCode', 'loadingPortCode', job, resultJson)" @focus="handleFocus('loadingPortCode')" /></el-form-item>
                <cargo-advance-select
                  no="46"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  filterable
                  :default-value="job.loadingPortCode"
                  tag-name="englishName"
                  style="width: 180px;"
                  @parentCallBack="p=>{job.loadingPortCode=p.value;}"
                  @focus="handleFocus('loadingPortCode')"
                />
              </div>
            </td>
            <td class="header">{{ $t('Payment.portOfTransfer') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.transferPortCode" no="47" @change="mapperSeaPort('transferPortCode', 'transferPortCode', job, resultJson)" @focus="handleFocus('transferPortCode')" /></el-form-item>
                <cargo-advance-select
                  no="48"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  filterable
                  :default-value="job.transferPortCode"
                  style="width: 180px;"
                  @parentCallBack="p=>{job.transferPortCode=p.value;}"
                  @focus="handleFocus('transferPortCode')"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="header is-require">{{ $t('queryJob.dischargingPortCode') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.dischargingPortCode" no="49" @change="mapperSeaPort('dischargingPortCode', 'dischargingPortCode', job, resultJson)" @focus="handleFocus('dischargingPortCode')" /></el-form-item>
                <cargo-advance-select
                  no="50"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  filterable
                  :default-value="job.dischargingPortCode"
                  style="width: 180px;"
                  @parentCallBack="p=>{job.dischargingPortCode=p.value}"
                  @focus="handleFocus('dischargingPortCode')"
                />
              </div>
            </td>
            <td class="header">{{ $t('queryJob.placeOfDelivery') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.destinationPortCode" no="51" @change="mapperSeaPort('destinationPortCode', 'destinationPortCode', job, resultJson)" @focus="handleFocus('destinationPortCode')" /></el-form-item>
                <cargo-advance-select
                  no="52"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  filterable
                  :default-value="job.destinationPortCode"
                  style="width: 180px;"
                  @parentCallBack="p=>{job.destinationPortCode=p.value}"
                  @focus="handleFocus('destinationPortCode')"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="header">{{ $t('SeaExport.Quantity') }}</td>
            <td><el-form-item><el-input v-model="resultJson.quantity" no="53" @focus="handleFocus('quantity')" /></el-form-item></td>
            <td class="header">{{ $t('SeaExport.Package') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.packing" no="54" @change="mapperPacking('', job, resultJson)" @focus="handleFocus('packing')" /></el-form-item>
                <cargo-packing-select :default-value="job.packing" style="width: 180px;" @change="p=>{job.packing=p.value}" @focus="handleFocus('packing')" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="header">{{ $t('SeaExport.Weight') }}</td>
            <td><el-form-item><el-input v-model="resultJson.grossWeight" no="55" @focus="handleFocus('grossWeight')" /></el-form-item></td>
            <td class="header">{{ $t('SeaExport.Cubage') }}</td>
            <td><el-form-item><el-input v-model="resultJson.cubage" no="56" @focus="handleFocus('cubage')" /></el-form-item></td>
          </tr>
          <tr>
            <td class="header">{{ $t('SeaExport.Marks') }}</td>
            <td><el-form-item><el-input v-model="resultJson.marks" type="textarea" resize="none" :rows="10" no="57" @focus="handleFocus('marks')" /></el-form-item></td>
            <td class="header">{{ $t('Pricing.Goods') }}</td>
            <td><el-form-item><el-input v-model="resultJson.goodName" type="textarea" resize="none" :rows="10" no="58" @focus="handleFocus('goodName')" /></el-form-item></td>
          </tr><tr>
            <td class="header">{{ $t('Payment.remarks') }}</td>
            <td colspan="3"><el-form-item><el-input v-model="resultJson.remark" type="textarea" resize="none" :rows="5" no="59" @focus="handleFocus('remark')" /></el-form-item></td>
          </tr>
        </table>
      </el-form>
    </div>
    <div v-if="showOtherField" class="section form-column" style="padding-top: 10px;">
      <el-form label-width="85px" label-position="right">
        <div style="padding-bottom: 15px;">
          <span>{{ $t('SeaExport.OcrOtherInfo') }}
            <el-popover
              placement="bottom"
              width="400"
              trigger="hover"
            >
              <div class="pop-content">{{ $t('SeaExport.OcrTip') }}</div>
              <svg-icon slot="reference" icon-class="question" style="font-size: 14px;margin-top: -3px;" />
            </el-popover>
          </span>
        </div>

        <el-form-item v-for="item in expressList" :key="item.name" :label="ColumnUtils.columnLabelFunc(SystemConstants.OCR_FIELDS, item.name)">
          <!-- 揽货类型-->
          <el-select
            v-if="item.name === 'cargoSource'"
            v-model="job.cargoSource"
            no="64"
            :placeholder="$t('SeaExport.PleaseSelect')"
            size="mini"
            style="width: 150px;"
          >
            <el-option
              v-for="(item,index) in SystemConstants.CARGO_SOURCES"
              :key="index"
              :label="isZh?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>
          <!-- 预计到货日期 warehouseInfo.arriveDate-->
          <el-date-picker
            v-if="item.name === 'arriveDate'"
            v-model="job.arriveDate"
            no="65"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            style="width: 150px;"
          />
          <!-- 截关日期-->
          <el-date-picker
            v-if="item.name === 'customCutoff'"
            v-model="job.customCutoff"
            no="66"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            style="width: 150px;"
          />
          <!-- 客户截关日期-->
          <el-date-picker
            v-if="item.name === 'customerCutoff'"
            v-model="job.customerCutoff"
            no="67"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            style="width: 150px;"
          />
          <!-- 客户退关日期-->
          <el-date-picker
            v-if="item.name === 'customerShutout'"
            v-model="job.customerShutout"
            no="68"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            style="width: 150px;"
          />
          <!-- 客户退关日期-->
          <el-date-picker
            v-if="item.name === 'customerFileCutoff'"
            v-model="job.customerFileCutoff"
            no="69"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            style="width: 150px;"
          />
          <cargo-user-select
            v-if="item.name === 'csr'"
            ref="csr"
            no="70"
            :method-params="{category:'role',shape:'csr'}"
            :default-value="job.csr||''"
            :merge-load="true"
            style="width: 150px;"
            @change="p=>{csrChangeHandler(p)}"
          />
          <cargo-user-select
            v-if="item.name === 'dc'"
            ref="dc"
            no="71"
            :method-params="{category:'role',shape:'doc'}"
            :default-value="job.dc||''"
            :merge-load="true"
            style="width: 150px;"
            @change="p=>{dcChangeHandler(p)}"
          />
          <!-- 小件数-->
          <auto-number-input
            v-if="item.name === 'insideQuantity'"
            v-model="job.insideQuantity"
            no="72"
            :precision="0"
            :min="0"
            style="width: 150px;"
            @valCallBack="(val)=>{
              job.insideQuantity = val
            }"
          />
          <!-- 小件包装-->
          <cargo-packing-select
            v-if="item.name === 'insidePacking'"
            no="73"
            :default-value="job.insidePacking"
            style="width: 150px;"
            @change="p=>{job.insidePacking=p.value}"
          />
          <!-- 计费重量RT-->
          <div v-if="item.name === 'chargeWeight'" style="display: flex">
            <auto-number-input
              v-model="job.chargeWeight"
              no="74"
              :precision="3"
              :min="0"
              style="flex:1;width: 135px;"
              @valCallBack="(val)=>{
                job.chargeWeight = val
              }"
            />
            <span>M/T</span>
          </div>
          <el-input
            v-if="item.name === 'userDefinedField1'"
            v-model="job.userDefinedField1"
            no="75"
            type="textarea"
            :rows="5"
            style="width: 150px;"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField1'),job.userDefinedField1,val=>{job.userDefinedField1=val})"
          />
          <el-input
            v-if="item.name === 'userDefinedField2'"
            v-model="job.userDefinedField2"
            no="76"
            type="textarea"
            :rows="5"
            style="width: 150px;"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField2'),job.userDefinedField2,val=>{job.userDefinedField2=val})"
          />
          <el-input
            v-if="item.name === 'userDefinedField3'"
            v-model="job.userDefinedField3"
            no="77"
            type="textarea"
            :rows="5"
            style="width: 150px;"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField3'),job.userDefinedField3,val=>{job.userDefinedField3=val})"
          />
          <el-input
            v-if="item.name === 'userDefinedField4'"
            v-model="job.userDefinedField4"
            no="78"
            type="textarea"
            :rows="5"
            style="width: 150px;"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField4'),job.userDefinedField4,val=>{job.userDefinedField4=val})"
          />
          <cargo-rich-textarea
            v-if="item.name === 'cargoChineseName'"
            v-model="job.cargoChineseName"
            no="cargoChineseName"
            :auto-uppercase="false"
            :auto-half-word="false"
            wrap-symbol="r"
            style="height: 110px"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),job.cargoChineseName,val=>{job.cargoChineseName=val})"
          />
        </el-form-item>
        <el-form-item v-if="job.cargoSource === CargoSource.NC_CARGO_SOURCE.code" :label="$t('SeaExport.NCReferenceNo')">
          <el-input v-model="job.agentRefNo" no="agentRefNo" />
        </el-form-item>
      </el-form>
    </div>

    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="advanceTextDialog"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeAdvanceText"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        no="advanceTextDialogTextarea"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :auto-uppercase="advanceTextDialog.formatObj.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button
          no="advanceTextDialogConfirm"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="advanceTextDialogClose"
          @click="closeAdvanceText()"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { cache, cacheName } from '@/utils/cacheManager'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { CONTAINERLOAD_TYPES } from '@/class/cargo/model/parameters/ContainerLoadType'
import CargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import CargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import ColumnUtils from '@/utils/ColumnUtils'
import { getOcrList } from '@/api/ocrSet'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import StrUtils from '@/utils/StrUtils'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { deepClone } from '@/utils'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as BlModeType from '@/class/cargo/model/parameters/BlModeType'
import DateUtils from '@/utils/dateUtils'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import { removeChineseCharacters } from '../../../../../../../tools/convertor/util/stringUtil'

export default {
  name: 'ResultFormSeCwmi',
  components: { CargoRichTextarea, AutoNumberInput, CargoUserSelect, CargoAdvanceSelect, CargoPackingSelect, cargoCompanySelect },
  props: {
    details: {
      type: Object,
      default: () => ({})
    },
    index: { type: Number, default: 0 },
    resultArray: { type: Array, default: () => [] }
  },
  data() {
    return {
      CargoSource,
      resultJson: {},
      containerLoadTypes: CONTAINERLOAD_TYPES,
      SystemConstants,
      ColumnUtils,
      selectTypeNames: TYPE_NAMES,
      useCase: 0, // 0 海运出口 1 空运出口
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0,
          autoHalfWord: false,
          autoUppercase: false
        }
      },
      otherField: {},
      expressList: [],
      mapperTexts: [],
      port: new Map(),
      carrier: new Map(),
      orderType: new Map(),
      loadType: new Map(),
      shippingTerm: new Map(),
      paymentTerm: new Map(),
      incoTerm: new Map(),
      eq: new Map(),
      customer: new Map(),
      packing: new Map(),
      blModeList: [
        { serialNumber: 1, code: 'ORIGINAL', name: 'ORIGINAL', localName: this.$t('SeaExport.OriginalNormal') },
        { serialNumber: 2, code: 'SURRENDERED', name: 'SURRENDERED', localName: this.$t('SeaExport.TelexRelease') },
        { serialNumber: 3, code: 'SEA WAYBILL', name: 'SEA WAYBILL', localName: this.$t('SeaExport.TelexRelease') }
      ],
      job: {},
      initJob: {
        customerId: 0,
        containerLoadType: '',
        carrierId: 0,
        freightTerm: '',
        paymentTermMBL: '',
        incoTerm: '',
        etd: '',
        seaEQ: [],
        loadingPortCode: '',
        transferPortCode: '',
        dischargingPortCode: '',
        destinationPortCode: '',
        packing: '',
        orderType: '',
        shipperLine1: '',
        shipperLine2: '',
        shipperLine3: '',
        shipperLine4: '',
        shipperLine5: '',
        shipperLine6: '',
        shipperLine7: '',
        consigneeLine1: '',
        consigneeLine2: '',
        consigneeLine3: '',
        consigneeLine4: '',
        consigneeLine5: '',
        consigneeLine6: '',
        consigneeLine7: '',
        notifyLine1: '',
        notifyLine2: '',
        notifyLine3: '',
        notifyLine4: '',
        notifyLine5: '',
        notifyLine6: '',
        notifyLine7: '',
        cargoSource: '',
        arriveDate: '',
        customCutoff: '',
        customerCutoff: '',
        customerShutout: '',
        customerFileCutoff: '',
        csr: 0,
        csrDepartment: 0,
        csrOffice: 0,
        dc: 0,
        dcDepartment: 0,
        dcOffice: 0,
        insideQuantity: 0,
        insidePacking: '',
        chargeWeight: 0,
        userDefinedField1: '',
        userDefinedField2: '',
        userDefinedField3: '',
        userDefinedField4: '',
        cargoChineseName: '',
        agentRefNo: ''
      }
    }
  },
  computed: {
    readOnly() {
      return this.details && this.details.status === 3
    },
    showOtherField() {
      return this.expressList && this.expressList.length > 0
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  watch: {
    // details(val, oldVal) {
    //   if (val.resultJson !== oldVal.resultJson) {
    //     this.init()
    //   }
    // },
    index(val, oldVal) {
      if (val !== oldVal) {
        // this.init()
        this.resultJson = this.resultArray[val].text.data
        this.job = this.resultJson.jobJson
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    await this.init()
  },
  methods: {
    handleFocus(val) {
      this.$emit('fieldFocus', val)
    },
    async init() {
      await this.initOcrSet()
      this.initOther()
      this.resultArray.forEach(result => {
        const resultJson = result.text.data
        // 将json信息转换成对应的值
        if (!resultJson.jobJson) {
          resultJson.jobJson = deepClone(this.initJob)
        }
        console.log('resultJson.jobJson:', resultJson.jobJson)
        const job = resultJson.jobJson
        this.initResultJson(job, resultJson)
      })
      this.resultJson = this.resultArray[this.index].text.data
      this.job = this.resultJson.jobJson
    },
    initResultJson(job, resultJson) {
      this.convertSft(job, resultJson)
      // 箱型、箱量
      this.setSeaEq(job, resultJson)
      this.convertMapper(job, resultJson)

      // // 唛头 未识别到时，显示N/M
      // if (!resultJson.marks) {
      //   resultJson.marks = 'N/M'
      // }
      job.marks = resultJson.marks
    },
    setSeaEq(job, resultJson) {
      try {
        job.seaEQ = []
        if (resultJson.containerInfos) {
          const dataArray = resultJson.containerInfos.split(',')
          for (const data of dataArray) {
            console.log('data:', data)
            const cData = data.split(/[:]/g)
            const eqData = {}
            eqData.eqQuantity = Number(cData[1] || 1)
            console.log('cData[0]:', cData[0])
            if (cData[0].includes('\'')) {
              const sizeTypeData = cData[0].split(/[']/g)
              eqData.eqSizeOrg = sizeTypeData[0]
              eqData.eqTypeOrg = sizeTypeData[1]
            } else {
              const match = cData[0].match(/^(\d+)([A-Za-z]+)/)
              eqData.eqSizeOrg = match[1]
              eqData.eqTypeOrg = match[2]
            }
            const eqSize = ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_EQSize, 'code', eqData.eqSizeOrg, 'code')
            const eqType = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_EQType, 'code', eqData.eqTypeOrg, 'code')
            if (eqSize && eqType) {
              eqData.eqSize = eqSize
              eqData.eqType = eqType
            }
            eqData.showEQ = 'X' + eqData.eqSizeOrg + '' + eqData.eqTypeOrg
            job.seaEQ.push(eqData)
          }
        }
      } catch (e) {
        console.log('ResultFormSeCwmi error', e)
      }
    },
    initOther() {
      getSpecificBasicData(basicCacheKeys.basic_data_BlMode).then(data => {
        for (const item of data) {
          if (item.orderType === BlModeType.HBL.code) {
            const blMode = this.blModeList.find(p => p.uuid === item.uuid)
            if (!blMode) {
              this.blModeList.push(item)
            }
          }
        }
      })
    },
    convertMapper(job, resultJson) {
      this.initMapper()
      // 委托单位
      if (!job.customerId || Number(job.customerId) <= 0) {
        this.mapperCustomerId(job, resultJson)
      }
      // 整箱拼箱
      if (StrUtils.isEmpty(job.containerLoadType) && !StrUtils.isEmpty(resultJson.containerLoadType)) {
        this.mapperLoadType(job, resultJson)
      }
      // 船公司
      if (!job.carrierId || Number(job.carrierId) <= 0) {
        this.mapperShipName(job, resultJson)
      }
      // 开航日期
      if (StrUtils.isEmpty(job.etd) && !StrUtils.isEmpty(resultJson.etd)) {
        this.mapperEtd(job, resultJson)
      }
      // 运输条款
      if (StrUtils.isEmpty(job.freightTerm) && !StrUtils.isEmpty(resultJson.freightTerm)) {
        this.mapperFreightTerm(job, resultJson)
      }
      // 运费条款
      if (StrUtils.isEmpty(job.incoTerm) && !StrUtils.isEmpty(resultJson.paymentTerm)) {
        this.mapperPaymentTerm(job, resultJson)
      }
      // 贸易条款
      if (StrUtils.isEmpty(job.incoTerm) && !StrUtils.isEmpty(resultJson.incoTerm)) {
        this.mapperIncoTerm(job, resultJson)
      }
      // 起运港
      if (StrUtils.isEmpty(job.loadingPortCode) && !StrUtils.isEmpty(resultJson.loadingPortCode)) {
        this.mapperSeaPort('loadingPortCode', 'loadingPortCode', job, resultJson)
      }
      // // 中转港
      // if (StrUtils.isEmpty(this.job.transferPortCode) && !StrUtils.isEmpty(this.resultJson.transferPortCode)) {
      //   this.mapperSeaPort('transferPortCode', 'transferPortCode')
      // }
      // // 存在交货地无卸货港，则默认将交货地的值赋值给卸货港
      // if (!StrUtils.isEmpty(resultJson.destinationPortCode) && StrUtils.isEmpty(resultJson.dischargingPortCode)) {
      //   resultJson.dischargingPortCode = resultJson.destinationPortCode
      // }
      // 卸货港
      if (StrUtils.isEmpty(job.dischargingPortCode) && !StrUtils.isEmpty(resultJson.dischargingPortCode)) {
        this.mapperSeaPort('dischargingPortCode', 'dischargingPortCode', job, resultJson)
      }
      // 交货地
      if (StrUtils.isEmpty(job.destinationPortCode) && !StrUtils.isEmpty(resultJson.destinationPortCode)) {
        this.mapperSeaPort('destinationPortCode', 'destinationPortCode', job, resultJson)
      }
      // 包装
      if (StrUtils.isEmpty(job.packing) && !StrUtils.isEmpty(resultJson.packing)) {
        this.mapperPacking('', job, resultJson)
      }
      // 提单形式
      if (StrUtils.isEmpty(job.orderType) && !StrUtils.isEmpty(resultJson.orderType)) {
        this.mapperOrderType(job, resultJson)
      }
    },
    // 转换收发通地址
    convertSft(job, resultJson) {
      if (job.shipperLine1 || job.consigneeLine1 || job.notifyLine1) return
      // // CARGO-43927 【通知人】 出现“同上”词组时，则转换为“SPREPAIDAME AS  CONSIGNEE”
      // if (resultJson.notify && resultJson.notify.trim() === '同上') {
      //   resultJson.notify = 'SAME AS CONSIGNEE'
      // }
      // // CARGO-43927 去除中文字符
      // const shipper = removeChineseCharacters(resultJson.shipper)
      // const consignee = removeChineseCharacters(resultJson.consignee)
      // const notifyParty = removeChineseCharacters(resultJson.notify)
      const shipper = resultJson.shipper
      const consignee = resultJson.consignee
      const notifyParty = resultJson.notify
      for (let i = 1; i < 8; i++) {
        job[`shipperLine${i}`] = ''
        job[`consigneeLine${i}`] = ''
        job[`notifyLine${i}`] = ''
        this.splitSft(shipper, 'shipperLine', job)
        this.splitSft(consignee, 'consigneeLine', job)
        this.splitSft(notifyParty, 'notifyLine', job)
      }
    },
    splitSft(oldVal, type, job) {
      if (oldVal) {
        if (typeof oldVal === 'string') {
          const oldValArr = oldVal.split('\n')
          const line7Arr = []
          for (let j = 0; j < oldValArr.length; j++) {
            if (j < 7) {
              job[type + `${j + 1}`] = oldValArr[j] ? oldValArr[j] : ''
              continue
            }
            line7Arr.push(oldValArr[j])
          }
          if (line7Arr.length > 0) {
            job[type + '7'] = line7Arr.join(',')
          }
        }
      }
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObject = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0,
        autoHalfWord: false,
        autoUppercase: false
      }
      this.advanceTextDialog.formatObj = formatObject ? { ...defaultFormatObj, ...formatObject } : defaultFormatObj
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    closeAdvanceText() {
      this.advanceTextDialog.visible = false
    },
    // 获取OCR映射
    async initOcrSet() {
      const params = {
        branchId: this.$store.getters.currentOfficeId,
        anyInteger: 0, // 应用场景 0海运出口托书识别
        anyBool: true // 应用场景 判断是否应用总部
      }
      await getOcrList(params).then(res => {
        const ocrSet = res.data
        if (ocrSet) {
          // 文字映射
          this.toMapperText(ocrSet)
          // 额外录单字段
          this.toOtherField(ocrSet)
        }
      })
    },
    // 文字映射
    toMapperText(ocrSet) {
      const mapperList = ocrSet.mapperList || []
      const mapperHqList = ocrSet.mapperHqList || []
      const otherMapper = mapperList.length > 0 ? mapperList[0] : null
      if (otherMapper && otherMapper.ifHq) {
        this.mapperTexts = mapperHqList
      }
      if (!this.mapperTexts || this.mapperTexts.length === 0) {
        this.mapperTexts = mapperList || []
      }
    },
    initMapper() {
      this.port = new Map()
      this.carrier = new Map()
      this.orderType = new Map()
      this.loadType = new Map()
      this.shippingTerm = new Map()
      this.paymentTerm = new Map()
      this.incoTerm = new Map()
      this.eq = new Map()
      this.customer = new Map()
      this.packing = new Map()
      const mapperTexts = this.mapperTexts
      if (!mapperTexts || mapperTexts.length <= 0) {
        return
      }
      for (const mapperText of this.mapperTexts) {
        const mapperKey = mapperText.type + '_' + mapperText.useCase + '_' + mapperText.oldText
        const mapperVal = mapperText.newText
        if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_PORT.code) {
          this.port.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_CARRIER.code) {
          this.carrier.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_BL_TYPE.code) {
          this.orderType.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_LOAD_TYPE.code) {
          this.loadType.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_SHIPPING_TERM.code) {
          this.shippingTerm.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_PAYMENT_TERM.code) {
          this.paymentTerm.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_INCO_TERM.code) {
          this.incoTerm.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_EQ.code) {
          this.eq.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_CUSTOMER.code) {
          this.customer.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_PACKING.code) {
          this.packing.set(mapperKey, mapperVal)
        }
      }
    },
    // 额外录单字段
    toOtherField(ocrSet) {
      const fieldList = ocrSet.fieldList || []
      const fieldHqList = ocrSet.fieldHqList || []
      const otherField = fieldList.length > 0 ? fieldList[0] : null
      let tempField = null
      if (otherField && otherField.ifHq) {
        tempField = fieldHqList.length > 0 ? fieldHqList[0] : null
      }
      if (!tempField) tempField = otherField
      if (!tempField) return
      const pattern = tempField.useField
      if (!pattern) {
        return
      }
      const expressList = []
      let index = -1
      for (let i = 0; i < pattern.length; ++i) {
        if (pattern[i] === '$' && pattern[i + 1] === '{') {
          index = i
          continue
        }
        if (pattern[i] === '}' && index > -1) {
          const name = pattern.substring(index + 2, i)
          const value = true
          expressList.push({ name, value })
          index = -1
        }
      }
      /* 表达式关联表单数据 */
      for (const item of expressList) {
        this.otherField[item.name] = !!item.value
      }
      this.$logger.log('expressList========', expressList)
      this.expressList = expressList
    },
    // 货物列表更改
    onGoodsCellChange() {

    },
    // 委托单位
    mapperCustomerId(job, resultJson) {
      if (!StrUtils.isEmpty(resultJson.customerId)) {
        // 用解析值 匹配 代码
        let customerId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cnShortName', resultJson.customerId, 'cmpIdx')
        if (!customerId) {
          // 用解析值 匹配 英文名
          customerId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'englishName', resultJson.customerId, 'cmpIdx')
          if (!customerId || Number(customerId) <= 0) {
            // 用解析值 匹配 中文名
            customerId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'chineseName', resultJson.customerId, 'cmpIdx')
            if (!customerId || Number(customerId) <= 0) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_CUSTOMER.code + '_' + this.useCase + '_' + resultJson.customerId
              const newMapperVal = this.customer.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                customerId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cnShortName', newMapperVal, 'cmpIdx')
                if (!customerId || Number(customerId) <= 0) {
                  // 用映射值 匹配 英文名
                  customerId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'englishName', newMapperVal, 'cmpIdx')
                  if (!customerId || Number(customerId) <= 0) {
                    // 用映射值 匹配 中文名
                    customerId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'chineseName', newMapperVal, 'cmpIdx')
                  }
                }
              }
            }
          }
        }
        job.customerId = customerId || 0
      }
    },
    // 船公司
    mapperShipName(job, resultJson) {
      if (!StrUtils.isEmpty(resultJson.carrier)) {
        // 用解析值 匹配 代码
        let carrierId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cnShortName', resultJson.carrier, 'cmpIdx')
        if (!carrierId) {
          // 用解析值 匹配 英文名
          carrierId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'englishName', resultJson.carrier, 'cmpIdx')
          if (!carrierId || Number(carrierId) <= 0) {
            // 用解析值 匹配 中文名
            carrierId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'chineseName', resultJson.carrier, 'cmpIdx')
            if (!carrierId || Number(carrierId) <= 0) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_CARRIER.code + '_' + this.useCase + '_' + resultJson.carrier
              const newMapperVal = this.carrier.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                carrierId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cnShortName', newMapperVal, 'cmpIdx')
                if (!carrierId || Number(carrierId) <= 0) {
                  // 用映射值 匹配 英文名
                  carrierId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'englishName', newMapperVal, 'cmpIdx')
                  if (!carrierId || Number(carrierId) <= 0) {
                    // 用映射值 匹配 中文名
                    carrierId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'chineseName', newMapperVal, 'cmpIdx')
                  }
                }
              }
            }
          }
        }
        job.carrierId = carrierId || 0
      }
    },
    mapperEtd(job, resultJson) {
      if (resultJson.etd) {
        let etd = DateUtils.toDateStr(resultJson.etd)
        if (!etd && resultJson.etd.length > 8) {
          etd = ColumnUtils.dateTimeLabelFunc(resultJson.etd)
        }
        job.etd = etd || ''
      }
    },
    // 整箱拼箱
    mapperLoadType(job, resultJson) {
      if (!StrUtils.isEmpty(resultJson.containerLoadType)) {
        // 用解析值 匹配 代码
        let loadType = ContainerLoadType.getContainerLoadTypeByCode(resultJson.containerLoadType)
        let loadTypeCode = loadType ? loadType.code : ''
        if (!loadTypeCode) {
          // 用解析值 匹配 中英文名
          loadType = ContainerLoadType.getContainerLoadTypeByName(resultJson.containerLoadType)
          loadTypeCode = loadType ? loadType.code : ''
          if (!loadTypeCode) {
            const mapperKey = SystemConstants.OCR_MAPPER_TYPE_LOAD_TYPE.code + '_' + this.useCase + '_' + resultJson.containerLoadType
            const newMapperVal = this.loadType.get(mapperKey)
            if (newMapperVal) {
              // 用映射值 匹配 代码
              loadType = ContainerLoadType.getContainerLoadTypeByCode(newMapperVal)
              loadTypeCode = loadType ? loadType.code : ''
              if (!loadTypeCode) {
                // 用映射值 匹配 中英文名
                loadType = ContainerLoadType.getContainerLoadTypeByName(newMapperVal)
                loadTypeCode = loadType ? loadType.code : ''
              }
            }
          }
        }
        job.containerLoadType = loadTypeCode || ''
      }
    },
    // 运输条款
    mapperFreightTerm(job, resultJson) {
      if (!StrUtils.isEmpty(resultJson.freightTerm)) {
        // 用解析值 匹配 代码
        let freightTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ShippingTerm, 'code', resultJson.freightTerm, 'code')
        if (!freightTerm) {
          // 用解析值 匹配 英文名
          freightTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ShippingTerm, 'name', resultJson.freightTerm, 'code')
          if (!freightTerm) {
            // 用解析值 匹配 中文名
            freightTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ShippingTerm, 'localName', resultJson.freightTerm, 'code')
            if (!freightTerm) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_SHIPPING_TERM.code + '_' + this.useCase + '_' + resultJson.freightTerm
              const newMapperVal = this.shippingTerm.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                freightTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ShippingTerm, 'code', newMapperVal, 'code')
                if (!freightTerm) {
                  // 用映射值 匹配 英文名
                  freightTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ShippingTerm, 'name', newMapperVal, 'code')
                  if (!freightTerm) {
                    // 用映射值 匹配 中文名
                    freightTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ShippingTerm, 'localName', newMapperVal, 'code')
                  }
                }
              }
            }
          }
        }
        job.freightTermHBL = freightTerm || ''
        job.freightTerm = freightTerm || ''
      }
    },
    // 运费条款
    mapperPaymentTerm(job, resultJson) {
      if (!StrUtils.isEmpty(resultJson.paymentTerm)) {
        // if (['PP', 'PREPAID'].indexOf(resultJson.paymentTerm.toUpperCase()) > -1) {
        //   resultJson.paymentTerm = 'FREIGHT PREPAID'
        // } else if (['CC', 'COLLECT'].indexOf(resultJson.paymentTerm.toUpperCase()) > -1) {
        //   resultJson.paymentTerm = 'FREIGHT COLLECT'
        // }
        // 用解析值 匹配 代码
        let paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'code', resultJson.paymentTerm, 'code')
        if (!paymenTerm) {
          // 用解析值 匹配 英文名
          paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'name', resultJson.paymentTerm, 'code')
          if (!paymenTerm) {
            // 用解析值 匹配 中文名
            paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'localName', resultJson.paymentTerm, 'code')
            if (!paymenTerm) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_PAYMENT_TERM.code + '_' + this.useCase + '_' + resultJson.paymentTerm
              const newMapperVal = this.paymentTerm.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'code', newMapperVal, 'code')
                if (!paymenTerm) {
                  // 用映射值 匹配 英文名
                  paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'name', newMapperVal, 'code')
                  if (!paymenTerm) {
                    // 用映射值 匹配 中文名
                    paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'localName', newMapperVal, 'code')
                  }
                }
              }
            }
          }
        }
        job.paymentTermHBL = paymenTerm || ''
        job.paymentTermMBL = paymenTerm || ''
      }
    },
    // 贸易条款
    mapperIncoTerm(job, resultJson) {
      if (!StrUtils.isEmpty(resultJson.incoTerm)) {
        // const cifRegex = /\b(CIF)\b/g
        // const fobRegex = /\b(FOB)\b/g
        // const dapRegex = /\b(DAP)\b/g
        // if (cifRegex.test(resultJson.incoTerm)) {
        //   resultJson.incoTerm = 'CIF'
        // } else if (fobRegex.test(resultJson.incoTerm)) {
        //   resultJson.incoTerm = 'FOB'
        // } else if (dapRegex.test(resultJson.incoTerm)) {
        //   resultJson.incoTerm = 'DAP'
        // }
        // 用解析值 匹配 代码
        let incoTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_IncoTerm, 'code', resultJson.incoTerm, 'code')
        if (!incoTerm) {
          // 用解析值 匹配 英文名
          incoTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_IncoTerm, 'name', resultJson.incoTerm, 'code')
          if (!incoTerm) {
            // 用解析值 匹配 中文名
            incoTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_IncoTerm, 'localName', resultJson.incoTerm, 'code')
            if (!incoTerm) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_INCO_TERM.code + '_' + this.useCase + '_' + resultJson.incoTerm
              const newMapperVal = this.incoTerm.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                incoTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_IncoTerm, 'code', newMapperVal, 'code')
                if (!incoTerm) {
                  // 用映射值 匹配 英文名
                  incoTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_IncoTerm, 'name', newMapperVal, 'code')
                  if (!incoTerm) {
                    // 用映射值 匹配 中文名
                    incoTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_IncoTerm, 'localName', newMapperVal, 'code')
                  }
                }
              }
            }
          }
        }
        job.incoTerm = incoTerm || ''
      }
    },
    // 起运港 中转港 卸货港 交货地
    mapperSeaPort(code = '', jsonCode = '', job, resultJson) {
      if (!code) return
      if (!resultJson[jsonCode]) return
      // 用解析值 匹配 代码
      let portCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', resultJson[jsonCode], 'code')
      if (!portCode) {
        // 用解析值 匹配 英文名
        portCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'englishName', resultJson[jsonCode], 'code')
        if (!portCode) {
          // 用解析值 匹配 中文名
          portCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'chineseName', resultJson[jsonCode], 'code')
          if (!portCode) {
            const mapperKey = SystemConstants.OCR_MAPPER_TYPE_PORT.code + '_' + this.useCase + '_' + resultJson[jsonCode]
            const newMapperVal = this.port.get(mapperKey)
            if (newMapperVal) {
              // 用映射值 匹配 代码
              portCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', newMapperVal, 'code')
              if (!portCode) {
                // 用映射值 匹配 英文名
                portCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'englishName', newMapperVal, 'code')
                if (!portCode) {
                  // 用映射值 匹配 中文名
                  portCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'chineseName', newMapperVal, 'code')
                }
              }
            }
          }
        }
      }
      job[code] = portCode || ''
    },
    // 包装
    mapperPacking(packingVal = '', job, resultJson) {
      let realPacking = resultJson.packing
      if (packingVal) { // 多单模式时 packingVal 有值
        realPacking = packingVal
      }
      let packingCode = ''
      if (!StrUtils.isEmpty(realPacking)) {
        // 用解析值 匹配 代码
        packingCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'code', realPacking, 'code')
        if (!packingCode) {
          // 用解析值 匹配 英文名
          packingCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'name', realPacking, 'code')
          if (!packingCode) {
            // 用解析值 匹配 中文名
            packingCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'chineseName', realPacking, 'code')
            if (!packingCode) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_PACKING.code + '_' + this.useCase + '_' + realPacking
              const newMapperVal = this.packing.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                packingCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'code', newMapperVal, 'code')
                if (!packingCode) {
                  // 用映射值 匹配 英文名
                  packingCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'name', newMapperVal, 'code')
                  if (!packingCode) {
                    // 用映射值 匹配 中文名
                    packingCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'chineseName', newMapperVal, 'code')
                  }
                }
              }
            }
          }
        }
        if (!packingVal) { // 多单模式时 packingVal 有值
          job.packing = packingCode || ''
        }
      }
      return packingCode
    },
    // 提单形式 ORIGINAL 正本 1/SURRENDERED 电放 2/SEA WAYBILL 电放 3
    mapperOrderType(job, resultJson) {
      if (!StrUtils.isEmpty(resultJson.orderType)) {
        let releaseType = 0
        const orderType = resultJson.orderType
        if (orderType === 'ORIGINAL') {
          releaseType = 1
        } else if (orderType === 'SURRENDERED') {
          releaseType = 2
        } else if (orderType === 'SEA WAYBILL') {
          releaseType = 3
        } else {
          releaseType = ColumnUtils.getBlModeSerialNumberByName(orderType)
        }
        if (releaseType) {
          const mapperKey = SystemConstants.OCR_MAPPER_TYPE_BL_TYPE.code + '_' + this.useCase + '_' + resultJson.orderType
          const newMapperVal = this.orderType.get(mapperKey)
          if (newMapperVal) {
            // 用映射值 匹配 中英文名
            releaseType = ColumnUtils.getBlModeSerialNumberByName(newMapperVal)
          }
        }
        job.orderType = releaseType
        job.seaCargoDoc = [{
          docType: 'HBL',
          releaseType: releaseType || 1
        }]
      }
    },
    etdChange(value) {
      this.job.etd = value
    },
    // 保存时获取数据
    getSubmitData() {
      const result = this.resultJson
      result.jobJson = this.job
      return result
    },
    // 客服改变
    async csrChangeHandler(data) {
      const job = this.job
      job.csr = data.value
      job.csrDepartment = 0
      job.csrOffice = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'csr', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.$store.getters.currentOfficeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.csrOffice = office ? office.officeId : 0
              job.csrDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'csr')
          if (dep) {
            job.csrDepartment = dep.departmentId
            const office = await Office.getOfficeByUuid(dep.officeUuid)
            job.csrOffice = office ? office.officeId : 0
          }
        }
      }
    },
    changeSizeCallBack(item, p) {
      item.eqSizeOrg = item.eqSize = p.value
      item.showEQ = 'X' + item.eqSizeOrg + '' + item.eqTypeOrg
    },
    changeTypeCallBack(item, p) {
      item.eqTypeOrg = item.eqType = p.value
      item.showEQ = 'X' + item.eqSizeOrg + '' + item.eqTypeOrg
    },
    // 单证改变
    async dcChangeHandler(data) {
      const job = this.job
      job.dc = data.value
      job.dcDepartment = 0
      job.dcOffice = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'doc', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.$store.getters.currentOfficeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.dcOffice = office ? office.officeId : 0
              job.dcDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'doc')
          job.dcDepartment = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.dcOffice = office ? office.officeId : 0
        }
      } else {
        job.dc = 0
        job.dcDepartment = 0
        job.dcOffice = 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.result-form{
  padding: 10px;
  table{
    width: 100%;
    tr{
      td {
        border: 1px solid #DCDFE6;
        height: 30px;
        &.header {
          width: 70px;
          text-align: center;
        }
        .el-form-item{
          margin: 0!important;
          input{
            border:none!important;
          }
        }
        .mapperClass {
          display: flex;
          align-items: center;
        }
      }
    }
  }
  .is-require {
    color: #4abff3;
  }
}
</style>
